/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "./Serviceinforamtion.css";
import { useTranslation } from "react-i18next";

const Serviceinforamtion = ({ homeData, serviceData }) => {
  const { t } = useTranslation("About");

  const homeDate = homeData?.data?.sections[2]?.Posts[0] || "";
  return (
    <div className="lg:my-24">
      <div id="services" className=" "></div>
      <div
        className="xl:scale-[92%] w-[80%] md:w-[90%] xl:w-[90%] mx-auto flex flex-col items-center justify-between mb-10 animate-section opacity-0 transition-opacity duration-1000
  md:block md:items-end md:flex-row md:justify-between"
      >
        <div className="flex flex-col gap-[24px] items-start z-[3] mt-16 sm:mt-8 md:w-[70%] ">
          <div className="flex flex-col gap-[4px] items-start self-stretch shrink-0 flex-nowrap relative z-[4]">
            <span className="flex  text_bold_Bukra  text-[1.79rem]  leading-[54.6px] text-[#0d6b70] ">
              {homeDate?.title}
            </span>
          </div>
          <span className="flex  29LT_Bukra  text-[1rem] font-normal leading-[29.12px] text-[#667680] xl:w-[80%]">
            {homeDate?.description}
          </span>
        </div>
        <img
          src="/icon/Vector7.png"
          className="relative w-[100%] xl:absolute xl:bottom-[-6%] ltr:rotate-y-180 xl:end-[-9rem] xl:w-[75%] animate-section opacity-0 transition-opacity duration-1000"
        />
      </div>

      <div className="xl:scale-[92%] lg:w-[80%] max-sm:w-full md:w-[90%] xl:w-[90%] mx-auto flex flex-col items-center md:flex-row md:items-end justify-between mb-10 animate-section  transition-opacity duration-1000">
        <div className="grid max-sm:gap-6 lg:grid-cols-3 max-sm:grid-cols-1 md:grid-cols-2">
          {serviceData?.data?.map((link, index) => (
<Link
  key={index}
  to={`/servicedetails/${link?.id}`}
  className="card xl:w-[22rem] md:w-[21rem] md:mx-5 max-sm:w-[20rem] rounded-2xl"
>
  <div className="card-content flex flex-col items-start gap-4 w-full h-full">
    <div className="text-[#0d6b70] text-xl font-bold 29LT_Bukra rtl:text-right w-full">
      {link?.name}
    </div>
    <div className="text-gray-500 text-sm font-medium list_style w-full">
      <span dangerouslySetInnerHTML={{ __html: link?.description }}></span>
    </div>
  </div>
</Link>


          ))}
        </div>
      </div>
      {serviceData?.data?.length > 0 && (
        <div className="flex justify-center mt-8 animate-section opacity-0 transition-opacity duration-1000">
          <Link
            to={"/service"}
            className="px-12 py-3 29LT_Bukra border border-[#0d6b70] text-[#0d6b70] hover:bg-[#0d6b70] hover:text-white hover:scale-90 rounded-full text-[14px] font-normal transition-all duration-500"
          >
            {t("All services")}
          </Link>
        </div>
      )}
    </div>
  );
};

export default Serviceinforamtion;
